import React from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import PropTypes from 'prop-types';
import CloseIcon from '@src/common/assets/modal_fntt_close_dark.svg';
import { Filters } from '../Filters';
import { SortBy } from '../SortBy';
import { styled } from '@uhg-abyss/web/tools/styled';

const Wrapper = styled('div', {
  background: 'rgb(255, 255, 255)',
  borderRadius: 0,
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  zIndex: 2,
  padding: 32,
});

const CloseIconWrap = styled('div', {
  height: '14px',
  width: '14px',
  cursor: 'pointer',
  margin: '0px 0 23px auto',
});

const TabletButtonWrap = styled('div', {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'end',
  paddingBottom: '16px',

  '& button': {
    width: '100%',
    '@screen >= $xs': {
      width: '50%',
    },
  },
});

const CloseIconStyle = styled('img', {
  display: 'flex',
  height: '14px',
  width: '14px',
  cursor: 'pointer',
  margin: '0px 0 23px auto',
});

export const SidePane = ({
  closeSidePane,
  sideView,
  applyFilters,
  showSort,
}) => {
  return (
    <React.Fragment>
      {sideView ? (
        <Wrapper>
          <CloseIconWrap>
            <CloseIconStyle
              src={CloseIcon}
              alt="Close Sidebar"
              onClick={closeSidePane}
              onKeyPress={() => {}}
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
              role="button"
            />
          </CloseIconWrap>
          <div>
            <TabletButtonWrap>
              <Button onClick={applyFilters}>Apply Filters</Button>
            </TabletButtonWrap>
          </div>
          <div>
            {showSort && <SortBy />}
            <Filters />
          </div>
        </Wrapper>
      ) : null}
    </React.Fragment>
  );
};

SidePane.propTypes = {
  closeSidePane: PropTypes.func,
  applyFilters: PropTypes.func,
  sideView: PropTypes.bool,
  showSort: PropTypes.bool,
};

SidePane.defaultProps = {
  closeSidePane: PropTypes.func,
  applyFilters: PropTypes.func,
  sideView: PropTypes.bool,
  showSort: PropTypes.bool,
};
